<template>
  <div v-loading.body="loading">
    <el-row class="filter" type="flex">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form ref="form" :model="form" label-width="85px" inline>
                <el-form-item>
                  <el-input
                    v-model="form.bonus_id"
                    placeholder="绩效ID"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.admin_id"
                    placeholder="员工工号"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-input
                    v-model="form.admin_name"
                    placeholder="员工名称"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item>
                  <el-select v-model="form.admin_status" placeholder="买手状态">
                    <el-option label="全部" value="0"></el-option>
                    <el-option label="启用" value="1"></el-option>
                    <el-option label="禁用" value="2"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="绩效月份">
                  <el-date-picker
                    v-model="form.record_date"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  ></el-date-picker>
                </el-form-item>
                <el-form-item label="">
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>

    <!-- 表格 -->
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          v-if="resData"
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="handleExportDetail"
            >导出绩效详情
          </el-button>
          <el-button type="success" size="mini" @click="handleExportList"
            >导出列表
          </el-button>
        </div>
        <div v-if="resData" style="margin-bottom: 0">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            height="600"
            :data="resData.list"
            tooltip-effect="dark"
            style="width: 100%"
          >
            <el-table-column prop="bonus_id" label="绩效ID" align="center">
            </el-table-column>
            <el-table-column prop="record_date" label="绩效月份" align="center">
            </el-table-column>
            <el-table-column prop="admin_id" label="买手ID" align="center">
            </el-table-column>
            <el-table-column prop="admin_name" label="买手名称" align="center">
            </el-table-column>
            <el-table-column prop="status_name" label="买手状态" align="center">
            </el-table-column>
            <el-table-column prop="bonus" label="绩效奖金" align="center">
            </el-table-column>
            <el-table-column label="操作" align="center" width="100">
              <template slot-scope="scope">
                <el-button
                  size="small"
                  type="text"
                  @click="handleShowDetail(scope.row.bonus_id)"
                  >查看详情</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="form.page"
            :page-size="form.page_size"
            :total="resData.total"
            layout="total,sizes, prev, pager, next, jumper"
            :page-sizes="[100, 200, 500]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>

    <!-- 查看详情弹窗 -->
    <el-dialog :visible.sync="isShowDetailDialog" center width="20%">
      <el-row>
        <el-col class="centerBox" style="font-size: 18px">
          {{ recordDate.split("-")[0] }}年{{
            recordDate.split("-")[1]
          }}月</el-col
        >
        <!-- <el-col :span="8" class="detailBtn">
          <el-button type="primary" size="mini">数据详情</el-button></el-col
        > -->
      </el-row>
      <el-row>
        <el-col :span="8" :offset="8" class="centerBox" style="font-size: 18px">
          绩效金额
        </el-col>
        <el-col
          :span="8"
          :offset="8"
          class="centerBox"
          style="font-size: 18px; color: #4072f5"
        >
          {{
            !isNaN(Number(bonusSum))
              ? (Number(bonusSum) >= 0 ? "¥" : `-&nbsp;￥`) +
                Math.abs(Number(bonusSum)).toFixed(2)
              : "Invalid"
          }}
        </el-col>
      </el-row>
      <el-row class="item-row">
        <el-col :span="12" class="left-text"> 买手名称 </el-col>
        <el-col :span="12" class="right-text">
          {{ adminName }}
        </el-col>
      </el-row>
      <el-row class="item-row">
        <el-col :span="12" class="left-text"> 买手ID </el-col>
        <el-col :span="12" class="right-text">
          {{ adminId }}
        </el-col>
      </el-row>
      <div v-for="(item, index) in kpiList" :key="index">
        <el-row class="item-row">
          <el-col :span="12" class="left-text"> {{ item.name }}</el-col>
          <el-col :span="12" class="right-text">
            <span
              :class="{
                'red-text': Number(item.bonus) >= 0,
                'green-text': Number(item.bonus) < 0,
              }"
              @click="handleShowDescription(item)"
            >
              {{
                !isNaN(Number(item.bonus))
                  ? (Number(item.bonus) >= 0 ? "¥" : "-&nbsp;¥") +
                    Math.abs(Number(item.bonus)).toFixed(2)
                  : "Invalid"
              }}
            </span>
            <i class="el-icon-arrow-right" />
          </el-col>
        </el-row>
      </div>
    </el-dialog>

    <!-- 查看说明弹窗 -->
    <el-dialog
      :visible.sync="isShowDescriptionDialog"
      title="指标说明"
      center
      width="20%"
    >
      <div>
        <el-row class="item-row">
          <el-col :span="12" class="left-text"> {{ description.name }} </el-col>
          <el-col :span="12" class="right-text">
            {{
              !isNaN(Number(description.bonus))
                ? (Number(description.bonus) >= 0 ? "¥" : "-&nbsp;¥") +
                  Math.abs(Number(description.bonus)).toFixed(2)
                : "Invalid"
            }}
          </el-col>
        </el-row>
        <div v-for="(item, index) in description.explain" :key="index">
          <el-row>
            <el-col :span="12" class="left-text"> {{ item.key }}</el-col>
            <el-col v-html="item.value" />
          </el-row>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";
import {
  postGetList,
  postExportDetail,
  postExportList,
  postGetDetail,
} from "@/openapi/erp/bonus.js";

export default {
  data() {
    return {
      resData: {
        total: 0,
      },
      form: {
        role: 1,
        page: 1,
        page_size: 100,
      },
      loading: false, // 加载动画是否显示
      tableLoading: false,
      filterFold: false,
      isShowDetailDialog: false,
      isShowDescriptionDialog: false,
      bonusSum: "", // 绩效金额
      recordDate: "", // 绩效月份
      adminName: "", // 买手名称
      adminId: "", // 买手ID
      kpiList: [],
      description: {},
    };
  },
  computed: {
    filteredForm() {
      const filtered = this.form;
      for (const key in filtered) {
        if (
          filtered[key] === undefined ||
          filtered[key] === "" ||
          filtered[key] === null
        ) {
          delete filtered[key];
        }
      }
      return filtered;
    },
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    handleExportDetail() {
      postExportDetail(this.filteredForm)
        .then((res) => {
          window.open(apiBaseURL + res.file);
        })
        .catch((error) => {
          this.$message.error(error);
          console.log("error: ", error);
        });
    },
    handleExportList() {
      postExportList(this.filteredForm)
        .then((res) => {
          window.open(apiBaseURL + res.file);
        })
        .catch((error) => {
          this.$message.error(error);
          console.log("error: ", error);
        });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    fetchData(showLoading) {
      this.loading = true;
      postGetList(this.filteredForm)
        .then((res) => {
          this.loading = false;
          this.resData = res;
        })
        .catch((error) => {
          this.loading = false;
          this.resData = [];
          console.log("error: ", error);
        });
    },
    handleSizeChange(val) {
      this.form.page_size = val;
      this.fetchData(true);
    },
    handleCurrentChange(val) {
      this.form.page = val;
      this.fetchData(true);
    },

    search() {
      this.fetchData();
    },
    handleShowDetail(val) {
      this.isShowDetailDialog = true;
      postGetDetail({ bonus_id: val })
        .then((res) => {
          const {
            bonus_sum: bonusSum,
            record_date: recordDate,
            admin_id: adminId,
            admin_name: adminName,
            kpi_list: kpiList,
          } = res;
          this.bonusSum = bonusSum;
          this.recordDate = recordDate;
          this.adminId = adminId;
          this.adminName = adminName;
          this.kpiList = kpiList;
        })
        .catch((error) => {
          console.log("error: ", error);
        });
    },
    handleShowDescription(val) {
      this.isShowDescriptionDialog = true;
      this.description = val;
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.centerBox {
  text-align: center;
}

.detailBtn {
  text-align: right;
}

.item-row {
  border-bottom: 1px solid #ccc;
  padding: 0 10px 10px;
  cursor: pointer;
}

.left-text {
  font-weight: 900;
}

.right-text {
  text-align: right;
}

.red-text {
  color: #a93232;
}

.green-text {
  color: #508908;
}
</style>



// WEBPACK FOOTER //
// src/pages/picker/Board.vue